import { render, staticRenderFns } from "./growthValue.vue?vue&type=template&id=0f2d732a&scoped=true"
import script from "./growthValue.vue?vue&type=script&lang=js"
export * from "./growthValue.vue?vue&type=script&lang=js"
import style0 from "./growthValue.vue?vue&type=style&index=0&id=0f2d732a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2d732a",
  null
  
)

export default component.exports